import React, { useContext } from "react";
import "./App.css";
import "mapbox-gl/dist/mapbox-gl.css";
import { AppContext, Tab } from "./components/AppContext";
import { MapController } from "./components/MapController";
import { RouteTab } from "./components/RouteTab";
import { VenueTab } from "./components/VenueTab";
import { Tabs } from "./components/Tabs";
import { Logo } from "./components/Logo";
import { AboutTab } from "./components/AboutTab";
import { ShareModal } from "./components/ShareModal";
import { MultipleVenueModal } from "./components/MultipleVenueModal";
import { Filters } from "./components/Filters";
import ReactTooltip from "react-tooltip";
import { InfoTooltip } from "./components/Tooltip";
import { TOOLTIP_COPY } from "./utils/tooltips";
import { MobileModal } from "./components/MobileModal";
import { FiltersModal } from "./components/FiltersModal";

function App() {
  const {
    tab,
    isShareModalOpen,
    setIsShareModalOpen,
    venueOptions,
    setVenueOptions,
    mobileToggle,
    showFilters,
    setShowFilters,
    filteredVenues,
    venues,
  } = useContext(AppContext);
  return (
    <div className="fixed top-0 bottom-0 right-0 left-0">
      <ReactTooltip multiline={true} />
      <ShareModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
      />
      <MultipleVenueModal
        isOpen={venueOptions.length > 0}
        onClose={() => setVenueOptions([])}
      />
      <MobileModal />
      <FiltersModal />
      <div className="h-full w-full antialiased overflow-hidden flex flex-row">
        {/* Column */}
        <div
          className={
            "application-content w-full md:w-auto max-w-full fixed md:static top-0 left-0 bottom-0 md:left-0 md:h-auto shadow flex flex-row z-20 transition-all duration-500 " +
            (mobileToggle
              ? "translate-x-0"
              : "-translate-x-full md:translate-x-0")
          }
        >
          <div className={"flex-1 h-full flex flex-col application-texture"}>
            {/* Header */}
            <Logo />
            <Tabs />
            {tab === Tab.VENUES && (
              <>
                <div className="container-margin flex-grow flex flex-col relative -mt-1">
                  <div className="flex flex-row py-4 lg:mb-2">
                    <div className="flex-1">
                      <h3 className="heading-3">
                        Venues <InfoTooltip msg={TOOLTIP_COPY.venues} />
                      </h3>
                    </div>
                    <div className="lg:hidden">
                      <button
                        onClick={() => setShowFilters(!showFilters)}
                        className="paragraph"
                      >
                        <svg
                          className="inline-block -mt-1 mr-1"
                          width="15px"
                          viewBox="0 0 15 14.98"
                        >
                          <g id="g3015">
                            <path d="M14.94.41a.62.62,0,0,1-.15.75L9.54,6.4v7.9a.65.65,0,0,1-.41.63.86.86,0,0,1-.27.05.66.66,0,0,1-.48-.2L5.66,12.05a.62.62,0,0,1-.2-.48V6.4L.21,1.16A.62.62,0,0,1,.06.41.64.64,0,0,1,.69,0H14.31A.64.64,0,0,1,14.94.41Z" />
                          </g>
                        </svg>{" "}
                        Filter
                      </button>
                    </div>
                  </div>
                  {tab === Tab.VENUES && (
                    <div className="flex place-content-between md:block small-copy text-right -mt-1 mb-4 lg:absolute lg:right-0 lg:bottom-7 lg:my-0">
                      <div>Showing {filteredVenues.length} of {venues.length}</div>
											<div><a className="underline" href="https://forms.monday.com/forms/22e700c33474c0b677861241eee479f0?r=use1" target="_blank">Add Venue/Festival</a></div>
                    </div>
                  )}
                </div>

                {/* <div className={`${showFilters ? 'flex-grow max-h-full' : 'flex-shrink max-h-0'} transition-all container-margin border-b border-black pb-4 md:pb-5`}>
                <div className={`${showFilters ? 'opacity-100' : 'overflow-hidden opacity-0 pointer-events-none'} transition-all pt-3`}>
                  <Filters />
                </div>
              </div> */}
              </>
            )}
            {tab === Tab.VENUES && <VenueTab />}
            {tab === Tab.ROUTE && <RouteTab />}
            {tab === Tab.ABOUT && <AboutTab />}
          </div>
        </div>

        {/* Map */}
        <div className={"flex-1"}>
          <MapController />
        </div>
      </div>
    </div>
  );
}

export default App;
